<email-layout>
  <ng-container logo>
    <email-tellent-logo />
  </ng-container>

  <ng-container header>
    <email-message-header [header]="data.title" [subheader]="data.p1" />
  </ng-container>

  <ng-container body>
    <email-text [contents]="data.p2_html" presetName="paragraph" />
    <email-text [contents]="data.p3_html" presetName="paragraph" />
    <email-margin [height]="28" />
    <email-text [contents]="data.p4" presetName="paragraph" />
    <email-margin [height]="28" />
    <hr />
    <email-margin [height]="28" />
    <email-text
      [contents]="data.p5_html"
      presetName="paragraph"
      className="web-tellent-contains-link"
    />
    <email-margin [height]="28" />
    <email-button [label]="data.stop_label" [href]="data.stop_url" theme="danger" />
  </ng-container>

  <ng-container footer>
    <email-text
      [contents]="data.footer.text"
      color="light"
      presetName="inline"
      size="small"
    />&nbsp;
    <email-link
      [label]="data.footer.label"
      [href]="data.footer.href"
      [target]="data.footer.target"
      [textOpts]="{ size: 'small', color: 'light' }"
      textPreset="inline"
    />
    <email-margin [height]="16" />
    <email-tellent-products-footer />
  </ng-container>
</email-layout>
